module.exports = __webpack_public_path__ + "static/images/redelivery-stop.svg";